/**
 * Video list component JS.
 */

import { h, app } from 'hyperapp'
import { AllHtmlEntities as Entities } from 'html-entities';

import Dropdown from './inc/Dropdown';

if ( typeof programData !== 'undefined' ) {
	( function( programData ) {
		if ( ! document.getElementById( 'program-finder' ) ) {
			return
		}

		/**
		 * Functions
		 */
		const changeUrlParam = ( urlParam ) => {
     if ( typeof( history.pushState ) !== 'undefined' ) {
         history.pushState( null, document.title, urlParam );
     } else {
         alert( 'Your browser does not support HTML5. Please download a more modern browser' );
     }
 		}

		const getFilterUrlParams = ( filters, state ) => {
			const matchedDegree = state.degrees.find( degree => degree.term_id === parseInt( filters.degree.value ) );
			const matchedSchool = state.schools.find( school => school.term_id === parseInt( filters.school.value ) );

			return serializeParams( {
				degree: matchedDegree ? matchedDegree.slug : '',
				school: matchedSchool ? matchedSchool.slug : '',
			} )
		}

		const serializeParams = ( obj ) => {
			let str = "?";
			for (let key in obj) {
			    if (str !== "?") {
			        str += "&";
			    }
			    str += key + "=" + encodeURIComponent(obj[key]);
			}
			return str;
		}

		const groupAlphabetically = ( collection ) => {
			const grouped = collection.reduce( ( acc, item ) => {
				const firstLetter = item.display_title.charAt( 0 ).toLowerCase();

				if ( acc[ firstLetter ] ) {
					acc[ firstLetter ].push( item );
				} else {
					acc[ firstLetter ] = [ item ];
				}

				return acc;
			}, {} );

			for ( let group in grouped ) {
				grouped[ group ].sort( alphabetical )
			}

			return grouped;
		}

		const alphabetical = ( a, b ) => {
			if ( a.display_title && b.display_title ) {
				return a.display_title.localeCompare( b.display_title );
			}

			return a.localeCompare( b );
		}

		const filterPrograms = ( collection, filters ) => {
			if ( ! filters ) {
				return collection;
			}

			if ( filters.search.value && collection.length ) {
				const search = filters.search.value;

				collection = collection.filter( item => item.display_title.toLowerCase().indexOf( search.toLowerCase() ) !== -1 );
			}

			if ( filters.school.value && collection.length ) {
				const school = filters.school.value;

				collection = collection.filter( item => programData.relations.program_school[ school ].find( programId => item.ID === programId ) );
			}

			if ( filters.degree.value && collection.length ) {
				const degree = filters.degree.value;

				collection = collection.filter( item => programData.relations.degree[ degree ].find( programId => item.ID === programId ) );
			}

			if ( filters.alphabet.value && collection.length ) {
				const alphabet = filters.alphabet.value;

				// Find programs that start with the alphabet value.
				collection = collection.filter( item => item.display_title.toLowerCase().indexOf( alphabet.toLowerCase() ) === 0 )
			}

			return collection;
		}

		const filtersEmpty = ( filters ) => {
			for ( var filter in filters ) {
				// If the string is not empty.
				if ( filters[ filter ].value.length > 0 ) {
					return false;
				}
			}

			return true;
		}

		/**
		 * App Components
		 */
		const alphabet = [
			'A',
			'B',
			'C',
			'D',
			'E',
			'F',
			'G',
			'H',
			'I',
			'J',
			'K',
			'L',
			'M',
			'N',
			'O',
			'P',
			'Q',
			'R',
			'S',
			'T',
			'U',
			'V',
			'W',
			'X',
			'Y',
			'Z'
		];

		const entities = new Entities();

		const programsAlphabetically = groupAlphabetically( programData.programs );

		const getDefaultFilters = ( data ) => {
			if ( ! data.school_filter && ! data.degree_filter ) {
				return {
					'search': { value: '' },
					'school': { value: '' },
					'degree': { value: '' },
					'alphabet': { value: '' },
				};
			}

			const filters = {
				'search': { value: '' },
				'school': { value: '' },
				'degree': { value: '' },
				'alphabet': { value: '' },
			};

			if ( data.school_filter ) {
				const matchedSchool = data.schools.find( school => school.slug === data.school_filter );

				if ( matchedSchool ) {
					filters.school.value = matchedSchool.term_id;
				}
			}

			if ( data.degree_filter ) {
				const matchedDegree = data.degrees.find( degree => degree.slug === data.degree_filter );

				if ( matchedDegree ) {
					filters.degree.value = matchedDegree.term_id;
				}
			}

			return filters;
		}

		const defaultFilter = getDefaultFilters( programData );

		const state = {
			programs: programData.programs,
			programsAlphabetically: programsAlphabetically,
			degrees: programData.degrees,
			schools: programData.schools,
			relations: programData.relations,
			programType: programData.program_type,
			filters: defaultFilter,
		};

		const actions = {
			updateFilters: ( filter ) => ( state ) => {
				const nextState = Object.assign( {}, state );

				nextState.filters = Object.assign(
					{},
					state.filters,
					{
						[ filter.key ]: Object.assign(
							{},
							state.filters[ filter.key ],
							{ value: filter.value }
						)
					}
				);

				changeUrlParam( getFilterUrlParams( nextState.filters, nextState ) );

				return nextState;
			},
			clearFilters: () => ( state ) => {
				const nextState = Object.assign( {}, state );

				nextState.filters = Object.assign(
					{},
					{
						'search': { value: '' },
						'school': { value: '' },
						'degree': { value: '' },
						'alphabet': { value: '' },
					}
				);

				return nextState;
			}
		};

		const view = ( state, actions ) => {
			let classname = 'program-finder__container';
			classname += state.programType ? ' ' + state.programType : '';

			return (
				<div class={ classname }>
					<Filters actions={ actions } state={ state } />
					<AlphabetFilter state={ state } actions={ actions } />
					<ProgramList state={ state } />
				</div>
			)
		}

		const Filters = ( { actions, state } ) => {
			const updateFilters = actions.updateFilters;
			const filters = state.filters;
			const degrees = state.degrees.filter( degree => {
				if ( state.relations.degree[ degree.term_id ] && state.relations.degree[ degree.term_id ].length ) {
					return true;
				}

				return false;
			} );
			const schools = state.schools.filter( school => {
				if ( state.relations.program_school[ school.term_id ] && state.relations.program_school[ school.term_id ].length ) {
					return true;
				}

				return false;
			} );

			const updateField = ( filter ) => ( event ) => {
				const value = event.target.value;

				if ( state.filters[ filter ].value === value ) {
					return;
				}

				updateFilters( { key: filter, value: value } );
			}

			const ClearFilters = ! filtersEmpty( state.filters ) ? <button onclick={ actions.clearFilters } class="reset clear-filters"><i class="icon-close clear-filters__icon"></i><span class="clear-filters__text">CLEAR FILTERS</span></button> : null;

			return (
				<div class ="program-finder__filters-container">
					<div class="program-finder__filters">
						<div class="program-finder__searchbar">
							<label for="search-programs-input" class="screen-reader-text">Search for programs.</label>
							<input id="search-programs-input" oninput={ updateField( 'search' ) } type="search" class="program-finder__searchbar-input" value={ state.filters.search.value } />
							<i class="icon-search program-finder__searchbar-icon"></i>
						</div>
						{ state.programType !== 'undergraduate' && <span class="or-text">OR</span> }
						{ state.programType !== 'undergraduate' && <SchoolFilter schools={ schools } updateFilters={ updateFilters } filters={ filters } /> }
						<span class="or-text">OR</span>
						<DegreeFilter degrees={ degrees } updateFilters={ updateFilters } filters={ filters } />
					</div>
					{ ClearFilters }
				</div>
			);
		}

		const DegreeFilter = ( { updateFilters, degrees, filters } ) => {
			const update = ( event, id, name ) => {
				if ( filters['degree'].value === id ) {
					return;
				}

				updateFilters( { key: 'degree', value: id } );
			}

			let header = null;

			const selectedDegree = degrees.find( degree => degree.term_id === filters.degree.value );

			if ( selectedDegree ) {
				header = selectedDegree.name;
			}

			if ( degrees ) {
				return <Dropdown list={ degrees } header="All Degree Types" onClickFunc={ update } selectedItem={ header } />
			}

			return null;
		}

		const SchoolFilter = ( { updateFilters, schools, filters } ) => {
			const update = ( event, id, name ) => {
				if ( filters['school'].value === id ) {
					return;
				}

				updateFilters( { key: 'school', value: id } );
			}

			let header = null;

			const selectedSchool = schools.find( school => school.term_id === filters.school.value );

			if ( selectedSchool ) {
				header = selectedSchool.name;
			}

			if ( schools ) {
				return <Dropdown list={ schools } header="All Schools" onClickFunc={ update } selectedItem={ header } />
			}

			return null;
		}

		const AlphabetFilter = ( { state, actions } ) => {
			const programsAlphabetically = groupAlphabetically( state.programs );
			const currentAlphabetLetter = state.filters.alphabet.value;
			const { updateFilters } = actions;

			const updateAlphabetFilter = ( event ) => {
				let value = event.target.textContent;
				const filter = 'alphabet';

				// If the value is the same, toggle off the button.
				if ( value === currentAlphabetLetter ) {
					value = '';
				}

				updateFilters( { key: filter, value: value } );
			}

			const createButton = ( letter ) => {
				const attributes = {
					'class': 'reset alphabet-letter',
					'onclick': updateAlphabetFilter
				};

				if ( ! programsAlphabetically[ letter.toLowerCase() ] ) {
					attributes.disabled = true;
				}

				if ( letter === currentAlphabetLetter ) {
					attributes.class += ' active';
					attributes['aria-pressed'] = true;
				}

				return h(
					'button',
					attributes,
					letter
				);
			}

			return (
				<div class="program-finder__alphabet-filter">
					<span class="screen-reader-text">Filter results by alphabet.</span>
					{ alphabet.map( createButton ) }
				</div>
			)
		}

		const ProgramList = ( { state } ) => {
			let { programs, programsAlphabetically, filters, relations } = state;
			programs = filterPrograms( programs, filters );
			programsAlphabetically = groupAlphabetically( programs );

			return (
				<div class="program-finder__list">
					<header class="program-finder__header">
						<h2 class="program-finder__header-item">Program</h2>
						<h2 class="program-finder__header-item">Degree Type</h2>
						{ state.programType !== 'undergraduate' && <h2 class="program-finder__header-item">School</h2> }
					</header>
					{ alphabet.map( letter => letter.toLowerCase() ).filter( letter => letter in programsAlphabetically ).map( letter => {
						return (
							<div class="program-finder__section">
								<div class="program-finder__letter-row">{ letter.toUpperCase() }</div>
								<div class="program-finder__programs">
									{ programsAlphabetically[ letter ].map( program => {
										return (
											<ProgramItem program={ program } state={ state } />
										)
									} ) }
								</div>
							</div>
						);
					} ) }
				</div>
			)
		}

		const ProgramItem = ( { program, state } ) => {
			let schools = null;

			if ( state.programType !== 'undergraduate' && state.relations.program_relations[ program.ID ] && state.relations.program_relations[ program.ID ]['program_school'] ) {
				schools = state.schools.filter( school => {
					return state.relations.program_relations[ program.ID ]['program_school'].find( schoolId => school.id === schoolId );
				} );
			}

			const SchoolComponent = schools ? <h3 class="program-finder__program-value program__school">{ schools.map( school => entities.decode( school.name ) ).join( ', ' ) }</h3> : <h3 class="program-finder__program-value program__school"></h3>;

			let degrees = null;
			if ( state.relations.program_relations[ program.ID ] && state.relations.program_relations[ program.ID ]['degree'] ) {
				degrees = state.degrees.filter( degree => {
					return state.relations.program_relations[ program.ID ]['degree'].find( degreeId => degree.id === degreeId );
				} );
			}

			const DegreeComponent = degrees ? <h3 class="program-finder__program-value program__degree">{ degrees.map( degree => entities.decode( degree.name ) ).join( ', ' ) }</h3> : <h3 class="program-finder__program-value program__degree"></h3>;

			return (
				<div class="program-finder__program">
					<ProgramLink program={ program } />
					{ DegreeComponent }
					{ state.programType !== 'undergraduate' && SchoolComponent }
				</div>
			);
		}

		const ProgramLink = ( { program } ) => {
			const linkAttributes = {
				class: 'program__link',
				href: entities.decode( program.link.url ),
				target: program.link.isExternal ? '_blank' : null,
				title: program.link.screenReaderText ? program.link.screenReaderText : null
			}

			const textAttributes = {
				class: 'program-finder__program-value program__title'
			}

			const screenReaderText = program.link.screenReaderText ? h( 'span', { class: 'screen-reader-text' }, program.link.screenReaderText ) : null;

			return h(
				'a',
				linkAttributes,
				h(
					'h3',
					textAttributes,
					[
						screenReaderText,
						entities.decode( program.display_title )
					]
				)
			);
		}

		const App = app( state, actions, view, document.getElementById( 'program-finder' ) )

	} ( programData ) );
}



// WEBPACK FOOTER //
// ./assets/js/program-finder.js